import { render, staticRenderFns } from "./TemplateSingleVideo.vue?vue&type=template&id=693f2d6a&scoped=true&"
import script from "./TemplateSingleVideo.vue?vue&type=script&lang=js&"
export * from "./TemplateSingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSingleVideo.vue?vue&type=style&index=0&id=693f2d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693f2d6a",
  null
  
)

export default component.exports